var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoAlmaajoBlack = function SvgLogoAlmaajoBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 679.22 124.51"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-almablack{fill:#000;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-almablack",
    points: "122.88 43.37 79.51 43.37 79.51 0 65.06 0 65.06 57.83 122.88 57.83 122.88 43.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-almablack",
    d: "M14.46,36.14H43.37v7.23H14.46ZM0,0V14.46H43.37v7.22H0V57.83H57.83V0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-almablack",
    points: "0 65.06 0 122.88 14.46 122.88 14.46 79.51 21.68 79.51 21.68 122.88 36.14 122.88 36.14 79.51 43.37 79.51 43.37 122.88 57.83 122.88 57.83 65.06 0 65.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-almablack",
    d: "M79.51,101.2h28.92v7.23H79.51ZM65.06,65.06V79.51h43.37v7.23H65.06v36.14h57.82V65.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-almablack",
    d: "M286.49,123.71H279l-6.24-14.13.36-.73H241l.36.73-6.23,14.13h-7.54L253.36,65h7.32ZM270,102.33l-.73-.73L258.87,78l-1.74-5.87H257L255.17,78,244.8,101.6l-.72.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-almablack",
    d: "M337.45,123.71H297.73V65h6.88v51.4l-.72.8h33.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-almablack",
    d: "M406.33,123.71h-6.89V80.51h-.14l-3.92,9.35-17.83,34.65h-.15l-18-35.09-3.62-8.91h-.15v43.2h-6.89V65h6.17l19.71,39.15,2.9,6.89h.15l2.9-6.89L400.17,65h6.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-almablack",
    d: "M476.51,123.71H469l-6.24-14.13.37-.73H431l.36.73-6.23,14.13h-7.54L443.38,65h7.32ZM460,102.33l-.73-.73L448.89,78l-1.74-5.87H447L445.19,78,434.82,101.6l-.72.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-almablack",
    d: "M567.35,123.71h-7.54l-6.24-14.13.37-.73H521.82l.36.73L516,123.71h-7.54L534.22,65h7.32Zm-16.53-21.38-.73-.73L539.73,78,538,72.17h-.15L536,78,525.66,101.6l-.72.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-almablack",
    d: "M610.41,102.18c0,16.68-9.86,22.26-20.95,22.26a21.9,21.9,0,0,1-17.4-9l4.93-4.86c2.9,4.21,8,7.33,12.54,7.33,6.82,0,14-3.7,14-15.37V65h6.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-almablack",
    d: "M651.67,124.44c-18,0-27.48-11.89-27.48-29.72s9.5-30.45,27.48-30.45,27.55,12.54,27.55,30.45S669.5,124.44,651.67,124.44Zm.07-53.65c-14.64,0-20.44,10.81-20.44,23.93,0,12.9,5.87,23.2,20.44,23.2s20.37-10.3,20.37-23.2S666.46,70.79,651.74,70.79Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-almablack",
    x: 178.18,
    y: 0.49,
    width: 2,
    height: 123
  })))));
};
export default SvgLogoAlmaajoBlack;